import * as React from "react";
const SvgFiRrCoin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 2C5.271 2 0 4.855 0 8.5v7C0 19.145 5.271 22 12 22s12-2.855 12-6.5v-7C24 4.855 18.729 2 12 2M2 15.5v-3.36a9 9 0 0 0 1 .703v4.526c-.647-.6-1-1.244-1-1.868zm5 3.866a13 13 0 0 1-2-.719v-4.835q.936.36 2 .617zm4 .611a20 20 0 0 1-2-.193v-4.981q.97.131 2 .175zm4-.193q-.954.143-2 .193v-4.998a22 22 0 0 0 2-.175zm4-1.136a13 13 0 0 1-2 .719v-4.936a16 16 0 0 0 2-.617zm3-3.147c0 .624-.353 1.268-1 1.868v-4.526a9 9 0 0 0 1-.703zm-10-2.5c-5.893 0-10-2.372-10-4.5S6.107 4 12 4s10 2.372 10 4.5S17.893 13 12 13z"
    />
  </svg>
);
export default SvgFiRrCoin;
